// Comprehensive GA4 Event Tracking for Shopify
document.addEventListener('DOMContentLoaded', function() {
  // 1. Track Cart Icon Clicks in Header
  const cartButton = document.querySelector('.js-drawer-open-nav');
  if (cartButton) {
    cartButton.addEventListener('click', function() {
      trackGAEvent('cart_icon_click', {
        'event_category': 'Navigation',
        'event_label': 'Header Cart Icon'
      });
    });
  }
  
  // 2. Track "Continue Shopping" link in cart flyout
  const continueShoppingLinks = document.querySelectorAll('.drawer__close-button, .drawer__close a, a[href="/collections/all"]');
  continueShoppingLinks.forEach(link => {
    link.addEventListener('click', function() {
      trackGAEvent('continue_shopping_click', {
        'event_category': 'Cart',
        'event_label': 'Continue Shopping'
      });
    });
  });
  
  // 3. Track "View Cart" link in cart flyout
  const viewCartLinks = document.querySelectorAll('.cart__checkout, a[href="/cart"]');
  viewCartLinks.forEach(link => {
    link.addEventListener('click', function() {
      trackGAEvent('view_cart_click', {
        'event_category': 'Cart',
        'event_label': 'View Cart'
      });
    });
  });
  
  // 4. Track "Add to Cart" buttons
  setupAddToCartTracking();
  
  // 5. Track "Shop Products" navigation dropdown
  setupShopProductsTracking();
  
  // 6. Track subscription frequency interactions
  setupSubscriptionTracking();
  
  // 7. Setup Mutation Observer to catch dynamically loaded elements
  setupMutationObserver();
  
  console.log('GA4 event tracking initialized');
});

/**
 * Helper function to track GA4 events
 */
function trackGAEvent(eventName, eventParams) {
  if (typeof gtag === 'function') {
    gtag('event', eventName, {
      ...eventParams,
      'non_interaction': false,
      'timestamp': new Date().toISOString()
    });
    console.log(`GA4 Event tracked: ${eventName}`, eventParams);
  } else {
    console.error('GA4 tracking code not loaded properly');
  }
}

/**
 * Setup tracking for Add to Cart buttons
 */
function setupAddToCartTracking() {
  // Track standard add to cart buttons
  const addToCartButtons = document.querySelectorAll('button[name="add"], .add-to-cart, .product-form__cart-submit');
  
  addToCartButtons.forEach(button => {
    button.addEventListener('click', function() {
      // Get product information if available
      let productInfo = {};
      
      // Try to get product details from the page
      const productContainer = button.closest('.product, .product-single, [data-product-id]');
      
      if (productContainer) {
        const productTitle = productContainer.querySelector('.product__title, .product-single__title, h1, h2')?.textContent?.trim();
        const productPrice = productContainer.querySelector('.product__price, .product-single__price, .price')?.textContent?.trim();
        const productId = productContainer.dataset.productId || '';
        
        productInfo = {
          'item_id': productId,
          'item_name': productTitle,
          'price': productPrice,
          'quantity': 1
        };
      }
      
      trackGAEvent('add_to_cart', {
        'event_category': 'Ecommerce',
        'event_label': 'Add to Cart',
        'items': [productInfo]
      });
    });
  });
}

/**
 * Setup tracking for Shop Products navigation dropdown
 */
function setupShopProductsTracking() {
  // Target the Shop Products navigation link based on the provided HTML
  const shopProductsLinks = document.querySelectorAll('.site-nav--has-dropdown.site-nav--is-megamenu summary.site-nav__link');
  
  shopProductsLinks.forEach(link => {
    link.addEventListener('click', function() {
      // Get the link text to identify which dropdown was clicked
      const linkText = this.textContent.trim().split(' ')[0]; // Get first word of link text
      
      trackGAEvent('shop_products_click', {
        'event_category': 'Navigation',
        'event_label': `${linkText} Dropdown`,
        'dropdown_text': this.textContent.trim()
      });
    });
  });
}

/**
 * Setup tracking for subscription frequency interactions
 */
function setupSubscriptionTracking() {
  // Track clicks on subscription radio buttons
  document.addEventListener('click', function(event) {
    // Check if the clicked element is a subscription radio or its label
    const subscriptionElement = event.target.closest('.rc-radio, .rc_widget__option, [data-option-subsave]');
    
    if (subscriptionElement) {
      // Try to get subscription details
      const isSubscription = subscriptionElement.classList.contains('rc-option__subsave') || 
                            subscriptionElement.hasAttribute('data-option-subsave');
      
      // Find the price element if available
      const priceElement = subscriptionElement.querySelector('.rc-option__price, .rc_widget__price');
      const price = priceElement ? priceElement.textContent.trim() : '';
      
      // Find the discount element if available
      const discountElement = subscriptionElement.querySelector('.rc-option__discount, .rc_widget__option__discount');
      const discount = discountElement ? discountElement.textContent.trim() : '';
      
      // Find the option text
      const textElement = subscriptionElement.querySelector('.rc-option__text');
      const optionText = textElement ? textElement.textContent.trim() : 
                        (subscriptionElement.textContent.trim() || 'Subscription Option');
      
      // Get product info if possible
      const productForm = subscriptionElement.closest('form[action*="/cart/add"]');
      let productInfo = {};
      
      if (productForm) {
        const productJson = document.querySelector('[data-product-json]');
        if (productJson) {
          try {
            const product = JSON.parse(productJson.textContent);
            productInfo = {
              'product_id': product.id,
              'product_title': product.title
            };
          } catch (e) {
            console.error('Error parsing product JSON:', e);
          }
        }
      }
      
      trackGAEvent('subscription_option_selected', {
        'event_category': 'Subscription',
        'event_label': optionText,
        'subscription_type': isSubscription ? 'Subscribe' : 'One-time',
        'price': price,
        'discount': discount,
        ...productInfo
      });
    }
    
    // Track subscription frequency dropdown changes
    const frequencySelect = event.target.closest('select[name*="selling_plan"], .rc_widget__frequency__list');
    
    if (frequencySelect) {
      const selectedOption = frequencySelect.options ? 
                            frequencySelect.options[frequencySelect.selectedIndex] : 
                            frequencySelect;
      
      trackGAEvent('subscription_frequency_changed', {
        'event_category': 'Subscription',
        'event_label': 'Frequency Changed',
        'frequency': selectedOption.textContent.trim() || 'Unknown frequency'
      });
    }
  });
}

/**
 * Setup Mutation Observer to catch dynamically loaded elements
 */
function setupMutationObserver() {
  // Options for the observer (which mutations to observe)
  const config = { childList: true, subtree: true };
  
  // Create an observer instance linked to the callback function
  const observer = new MutationObserver((mutationsList, observer) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // Check for newly added cart elements
        const addedNodes = Array.from(mutation.addedNodes);
        const hasCartElements = addedNodes.some(node => {
          if (node.nodeType === 1) { // Element node
            return node.classList && (
              node.classList.contains('drawer__content') || 
              node.classList.contains('cart') ||
              node.querySelector('.drawer__content, .cart')
            );
          }
          return false;
        });
        
        if (hasCartElements) {
          // Re-attach event listeners to cart elements
          const continueShoppingLinks = document.querySelectorAll('.drawer__close-button, .drawer__close a, a[href="/collections/all"]');
          continueShoppingLinks.forEach(link => {
            link.addEventListener('click', function() {
              trackGAEvent('continue_shopping_click', {
                'event_category': 'Cart',
                'event_label': 'Continue Shopping'
              });
            });
          });
          
          const viewCartLinks = document.querySelectorAll('.cart__checkout, a[href="/cart"]');
          viewCartLinks.forEach(link => {
            link.addEventListener('click', function() {
              trackGAEvent('view_cart_click', {
                'event_category': 'Cart',
                'event_label': 'View Cart'
              });
            });
          });
        }
        
        // Check for newly added add-to-cart buttons
        const hasAddToCartButtons = addedNodes.some(node => {
          if (node.nodeType === 1) { // Element node
            return node.querySelector('button[name="add"], .add-to-cart, .product-form__cart-submit');
          }
          return false;
        });
        
        if (hasAddToCartButtons) {
          setupAddToCartTracking();
        }
        
        // Check for newly added subscription elements
        const hasSubscriptionElements = addedNodes.some(node => {
          if (node.nodeType === 1) { // Element node
            return node.querySelector('.rc-radio, .rc_widget__option, [data-option-subsave]');
          }
          return false;
        });
        
        if (hasSubscriptionElements) {
          setupSubscriptionTracking();
        }
      }
    }
  });
  
  // Start observing the document body for configured mutations
  observer.observe(document.body, config);
}